var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mockData as chatEventsData } from '@web/lib/demo/data/chatEvents';
import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { mockData as meetingsEventsData } from '@web/lib/demo/data/meetingEvents';
import { filterData } from '@web/lib/demo/utils';
import { ApplicationEnum } from '@workalizer/shared';
import { analyticUserActivitySummary } from '@workalizer/shared/services/analyticUserActivitySummary';
export var activitySummaryHeatmap = function (input) {
    var dataDocumentEvents = filterData(documentEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        }
    ]).map(function (event) { return ({
        id: event.id,
        date: new Date(event.date),
        count: 1,
        application_name: ApplicationEnum.DRIVE
    }); });
    var dataChatEvents = filterData(chatEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        }
    ]).map(function (event) { return ({
        id: event.id,
        date: new Date(event.date),
        count: 1,
        application_name: ApplicationEnum.CHAT
    }); });
    var dataMeetingsEvents = filterData(meetingsEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        }
    ]).map(function (event) { return ({
        id: event.id,
        date: new Date(event.date),
        count: 1,
        application_name: ApplicationEnum.MEET
    }); });
    var response = analyticUserActivitySummary(__spreadArray(__spreadArray(__spreadArray([], dataDocumentEvents, true), dataChatEvents, true), dataMeetingsEvents, true), new Date(input.dateFrom), new Date(input.dateTo), input.groupBy);
    return response;
};
